export default __webpack_public_path__ + "static/media/regulatory--no-parking-or-no-stopping--g1.32cc0e7c.png";